// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts"
// @generated from file tracker/v1/offer.proto (package tracker.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { ArchiveOfferRequest, ArchiveOfferResponse, CheckOfferLinkRequest, CheckOfferLinkResponse, CreateOfferRequest, CreateOfferResponse, GetOfferLibraryRequest, GetOfferLibraryResponse, GetOfferRequest, GetOfferResponse, GetOfferUsageRequest, GetOfferUsageResponse, ListOfferNumbersRequest, ListOfferNumbersResponse, ListOffersRequest, ListOffersResponse, UpdateOfferRequest, UpdateOfferResponse, ValidateOfferRequest, ValidateOfferResponse } from "./offer_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service tracker.v1.OfferService
 */
export const OfferService = {
  typeName: "tracker.v1.OfferService",
  methods: {
    /**
     * @generated from rpc tracker.v1.OfferService.ListOffers
     */
    listOffers: {
      name: "ListOffers",
      I: ListOffersRequest,
      O: ListOffersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.OfferService.GetOffer
     */
    getOffer: {
      name: "GetOffer",
      I: GetOfferRequest,
      O: GetOfferResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.OfferService.CreateOffer
     */
    createOffer: {
      name: "CreateOffer",
      I: CreateOfferRequest,
      O: CreateOfferResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.OfferService.UpdateOffer
     */
    updateOffer: {
      name: "UpdateOffer",
      I: UpdateOfferRequest,
      O: UpdateOfferResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.OfferService.ArchiveOffer
     */
    archiveOffer: {
      name: "ArchiveOffer",
      I: ArchiveOfferRequest,
      O: ArchiveOfferResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.OfferService.GetOfferUsage
     */
    getOfferUsage: {
      name: "GetOfferUsage",
      I: GetOfferUsageRequest,
      O: GetOfferUsageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.OfferService.ValidateOffer
     */
    validateOffer: {
      name: "ValidateOffer",
      I: ValidateOfferRequest,
      O: ValidateOfferResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.OfferService.ListOfferNumbers
     */
    listOfferNumbers: {
      name: "ListOfferNumbers",
      I: ListOfferNumbersRequest,
      O: ListOfferNumbersResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.OfferService.GetOfferLibrary
     */
    getOfferLibrary: {
      name: "GetOfferLibrary",
      I: GetOfferLibraryRequest,
      O: GetOfferLibraryResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc tracker.v1.OfferService.CheckOfferLink
     */
    checkOfferLink: {
      name: "CheckOfferLink",
      I: CheckOfferLinkRequest,
      O: CheckOfferLinkResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

